"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContourArea = getContourArea;
exports.getContourPerimeter = getContourPerimeter;
var _getPointTangent = require("./getPointTangent");
var _shortenEntities = require("./shortenEntities");
/**
 * Returns the exact perimeter of the contour.
 * @param contour The contour to get the perimeter of.
 * @returns The perimeter of the contour.
 */
function getContourPerimeter(contour) {
  let perimeter = 0;
  for (let entity of contour.entities) {
    perimeter += (0, _shortenEntities.entityLength)(entity);
  }
  return perimeter;
}

/**
 * Returns the exact area of the contour. The sign depends on the orientation of the contour. CCW contours have positive
 * area, CW contours have negative area.
 * @param contour The contour to get the area of.
 * @returns The area of the contour.
 */
function getContourArea(contour) {
  let area = 0;
  for (let entity of contour.entities) {
    let start = (0, _getPointTangent.getPointTangentOfEntity)(entity, entity.reversed ? 1 : 0)[0];
    let end = (0, _getPointTangent.getPointTangentOfEntity)(entity, entity.reversed ? 0 : 1)[0];
    switch (entity.type) {
      case 'LINE':
        area += 0.5 * (start.x * end.y - end.x * start.y);
        break;
      case 'CIRCLE':
        area += Math.PI * entity.r * entity.r * (entity.reversed ? -1 : 1);
        break;
      case 'ARC':
        // Add the area is if this was a line, and then add or subtract the area of the circular segment.
        area += 0.5 * (start.x * end.y - end.x * start.y);

        // https://en.wikipedia.org/wiki/Circular_segment
        let sweepAngle = entity.endAngle - entity.startAngle;
        let segmentArea = 0.5 * entity.r * entity.r * (sweepAngle - Math.sin(sweepAngle)) * (entity.reversed ? -1 : 1);
        area += segmentArea;
        break;
      default:
        throw new Error('Unsupported entity type');
    }
  }
  return area;
}